
export enum DsrSelectionTypeCd {
	AUTOMATED_SELECTION_BASED_ON_RANDOM_POOL = 'AutomatedSelectionBasedOnRandomPool',
	AUTOMATED_SELECTION_BASED_ON_UNCHECKED_POOL = 'AutomatedSelectionBasedOnUncheckedPool',
	MANUAL_SELECTION_BY_FOS = 'ManualSelectionByFOS',
	RECHECK_DUE_TO_COACHING = 'RecheckDueToCoaching',
	SELECTION_DUE_TO_A_FLAGGED_PU_ON_THE_TRIP = 'SelectionDueToAFlaggedPUOnTheTrip'}

